import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'modal-load-scenario',
  templateUrl: './load-scenario.component.html'
})
export class LoadScenarioModal implements OnInit {
  public items: Array<any> = [];  // Aquí almacenaremos los elementos de localStorage
  public loading: boolean = false;

  constructor(public dialog: MatDialogRef<LoadScenarioModal>) {}

  // Método para seleccionar un item y cerrar el modal
  public setSelected(item: any): void {
    if (item) {
      this.dialog.close(item);  // Cierra el modal y devuelve el item seleccionado
    }
  }

  // Método para eliminar un item del localStorage
  public deleteItem(key: string): void {
    const itemIndex = this.items.findIndex(item => item._key === key);
    if (itemIndex !== -1) {
      this.items.splice(itemIndex, 1);  // Eliminamos el item de la lista visual

      this.loading = true;

      // Eliminamos el item del localStorage
      localStorage.removeItem(key);

      // Simulamos un pequeño retardo para ocultar el "loading"
      setTimeout(() => {
        this.loading = false;
      }, 200);
    }
  }

  public loadItemsFromLocalStorage(): void {
    this.items = [];  // Limpiamos la lista antes de cargar los nuevos elementos
  
    // Recorremos el localStorage y agregamos las claves a 'items'
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || key === 'access_token') continue;  // Excluye 'access_token'
  
      // Solo guardamos las claves, no es necesario obtener el valor del item
      this.items.push(key);  // Aquí solo agregamos la clave
    }
  }
  

  // Función para determinar si el ítem es editable
  public isEditable(): boolean {
    // Lógica de si es editable o no
    return true;  // O cambia esto según tus necesidades
  }

  ngOnInit() {
    this.loadItemsFromLocalStorage();  // Cargamos los items al iniciar el modal
  }
}
